import * as React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentsIcon from '@mui/icons-material/Payments';
import { Post } from '../services/http';
import { validateForm } from '../services/validate';
import UploadImage from '../services/upload-image';
import './dialog.css';

export default function PayCheckPopup({ campaignID, campaignSlug, campaignName, isOpen = false, closePopup }) {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState(null);
    const [partnerLink, setPartnerLink] = React.useState(null);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        if (!isOpen) {
            setOpen(false);
        } else {
            closePopup(false);
        }
    };

    return (
        <div>
            {!isOpen ? (
                <a className="login_button2" onClick={handleClickOpen} style={{ fontSize:'18px', fontFamily:'Rubik', background: '#1D1E1D', color: 'white', alignItem: 'center', textDecoration: 'none', fontWeight: '500', paddingLeft: '70px', paddingRight: '70px', paddingTop: '20px', paddingBottom: '20px' }}>
                <img src="/img/sprite/dollar.png" width="35px" />  
                     To send a check / Zelle
                </a>
            ) : ''}
            <div id="popup-atboard" className={open || isOpen ? 'popup _open' : 'popup'}>
                <div className="popup__body">
                    <div className="popup__content">
                        <div onClick={handleClose} className="popup__close" >
                            <img src="/img/cross.png" style={{ width: '20px', height: '20px' }} alt="" />
                        </div>
                        <div className="popup__head mb-0">
                            <h2 className="rubik weight-600 color-1 f-24">Checks can be made out to: World of Tzedaka.</h2>
                            <h3 className="checks__mes weight-400 f-18 rubik color-5"> ‘World Of Tzedaka’, previously ’Tomchei Tzedaka Corp’ <br /> (Tax ID 81-4838703)</h3>
                        </div>
                        <hr style={{ margin: '0', color: 'rgba(21, 121, 190, 1)', border: '1px solid' }} />
                        <div className="checks" style={{ marginTop: '10px' }}>
                            <div className="checks__item border-r" >
                                <div style={{ height: '35px' }}><img src="/img/mail.png" className="pop-img-center" alt="" style={{ width: '30px', height: '22px' }}/></div>
                                <div className="checks__content">
                                    <div className="checks__title roboto weight-500 f-16">Mail:</div>
                                    <div className="checks__text roboto weight-400 f-16">P.o Box 1003, Lakewood NJ 08701</div>
                                    <div className="checks__mes roboto weight-400 f-16 color-5"> <span className="color-1">Please specify</span> #{campaignID} {campaignName?.substring(0, 30)}</div>
                                </div>
                            </div>
                            <div className="checks__item">
                                <div style={{ height: '35px' }}><img src="/img/money.png" className="pop-img-center" alt="" style={{ width: '30px', height: '30px' }}/></div>
                                <div className="checks__content">
                                    <div className="checks__title roboto weight-500 f-16">For Zelle:</div>
                                    <div className="checks__text roboto weight-400 f-16">info@worldoftzedaka.org</div>
                                    <div className="checks__mes roboto weight-400 f-16 color-5"> <span className="color-1">Please specify</span>  #{campaignID} {campaignName?.substring(0, 30)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center rubik weight-600 f-24 color-1 mt-20">
                            PLEASE DON’T FORGET TO SPECIFY FOR:
                            <div className="rubik weight-400 f-18 color-5">
                                #{campaignID} {campaignName?.substring(0, 30)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
